<div class="entry-card">
    <mat-card appearance="outlined" class="entry-wrapper">
        <mat-card-header>
            <mat-card-title>{{cardTitle}}</mat-card-title>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content>
            <div class="dash-icon">
                <app-svg-icon src="{{iconSrc}}" width="{{iconWidth}}" height="{{iconHeight}}"></app-svg-icon>
                <mat-card-title>
                    <h2>{{iconTitle}}</h2>
                </mat-card-title>
            </div>
        </mat-card-content>
        <mat-card-footer>
            <a [routerLink]="cardLink">
                <app-square-icon-btn color="primary" icon="{{cardLinkIcon}}" class="cta"
                    (click)="navigate()"></app-square-icon-btn>
            </a>
        </mat-card-footer>
    </mat-card>
</div>
